import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import FAQSection from './components/FAQSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <AppSection />
        <ContactSection />
        <CommentsSection />
        <CarouselSection />
        <FAQSection />
        <RankingSection />
        <FeaturesSection />
        <AboutSection />
        <TopicsSection />
        <UpdatesSection />
        <IndexSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}